export default __webpack_public_path__ + "static/media/photo--lg--53.28aa27a1.jpg";